import React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import TutorialJourneysService from "../../../services/TutorialJourneysService";
import { JourneyTemplateEditor } from "../../../components/admin/journey/JourneyTemplateEditor";
import { TutorialJourneyType } from "@growth-machine-llc/stridist-api-client";
import { useTutorialJourneyProfiles } from "../hooks/useTutorialJourneyProfiles";

export const TUTORIAL_JOURNEY_SINGLE_KEY = "tutorial-journey";

export function JourneyTemplate() {
  const { type } = useParams();

  const journeyType =
    TutorialJourneyType[type as keyof typeof TutorialJourneyType];

  const { data, isLoading: journeyIsLoading } = useQuery({
    queryKey: [TUTORIAL_JOURNEY_SINGLE_KEY, journeyType],
    queryFn: () =>
      TutorialJourneysService.getTutorialJourneyByType(journeyType),
    enabled: true,
    refetchOnMount: "always",
  });

  const { data: profilesVm, isLoading: profilesIsLoading } =
    useTutorialJourneyProfiles();

  const isLoading = journeyIsLoading || profilesIsLoading;

  return (
    <>
      {!isLoading && (
        <>
          <JourneyTemplateEditor
            data={data}
            profiles={profilesVm?.profiles}
            displayMode="joyride"
          />
        </>
      )}
    </>
  );
}
